import { FeedBackLevel } from '@chipinside/formbuilder'

import { Icon, IconProps } from '#/components/Icon'
import { pageBuilderColors } from '#/store/providers/Pagebuilder'

export type PageBuilderIconProps = {
  value?: IconProps['name']
  level?: FeedBackLevel
  size?: IconProps['size']
  disabled?: IconProps['disabled']
}

export const PageBuilderIcon = ({
  disabled,
  level,
  size = 'medium',
  value,
}: PageBuilderIconProps) => {
  const color = disabled ? undefined : pageBuilderColors?.feedback?.[level as FeedBackLevel]?.color

  return <Icon name={value} size={size} color={color} />
}
